import { render, staticRenderFns } from "./PortfolioOrDecisionNavigation.vue?vue&type=template&id=34bed5cf"
import script from "./PortfolioOrDecisionNavigation.vue?vue&type=script&lang=ts"
export * from "./PortfolioOrDecisionNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports